<template>
    <el-container v-loading="isShowLoading">
        <el-main>
            <el-row>
                <el-form :model="filterData" :inline="true">
                    <el-form-item>
                        <el-input v-model="filterData.fileName" placeholder="文件名称"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filterData.updateFlag" placeholder="是否已回传" style="width: 150px;">
                            <el-option value=""></el-option>
                            <el-option value="Y" label="已回传">已回传</el-option>
                            <el-option value="N" label="未回传">未回传</el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label style="width:30%">
                      <el-col :span="11">
                        <el-form-item style="width:100%;">
                          <el-date-picker
                            type="date"
                            placeholder="选择上传日期起"
                            v-model="filterData.uploadTimeBeg"
                            style="width: 100%;"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                      <el-col class="line" :span="2" align="center">-</el-col>
                      <el-col :span="11">
                        <el-form-item style="width:100%;">
                          <el-date-picker
                            placeholder="选择上传日期止"
                            v-model="filterData.uploadTimeEnd"
                            style="width: 100%;"
                            value-format="yyyy-MM-dd"
                          ></el-date-picker>
                        </el-form-item>
                      </el-col>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="onFilter">查询</el-button>
                        <el-button type="primary" size="small" icon="el-icon-refresh-left" @click="reset">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-row>
            <el-table ref="singleTable" :data="recordData" highlight-current-row style="width: 100%"
                :height="tableHeight" @row-dblclick="onRowDblclick"
                :header-cell-style="{background:'#f5f7fa', color: 'black'}" border :stripe="stripeVisible">
               <el-table-column type="index" width="50" label="序号"></el-table-column>
               <el-table-column label="文件名称" align="center" width="200">
                   <template slot-scope="scope">
                       <div>
                           <el-button @click="getBase64Online(scope.row)" type="text" size="small">
                               {{scope.row.fileName}} </el-button>
                       </div>
                   </template>
               </el-table-column>
               <el-table-column property="fileType" label="文件类型" width="80" align="center">
                   <template slot-scope="scope">
                       <div v-if="scope.row.fileType == '01'">
                           <i></i>初次筛查
                       </div>
                       <div v-else-if="scope.row.fileType == '02'">
                           <i></i>二次筛查
                       </div>
                   </template>
               </el-table-column>
               <el-table-column property="jgMc" label="单位名称" width="200" show-overflow-tooltip="true">
               </el-table-column>
               <el-table-column property="czryMc" label="上传人名称" width="100" show-overflow-tooltip="true">
               </el-table-column>
               <el-table-column property="uploadTime" label="上传时间" width="160" show-overflow-tooltip="true">
               </el-table-column>
               <el-table-column property="xgrMc" label="回传人名称" width="100" show-overflow-tooltip="true">
               </el-table-column>
               <el-table-column property="updateTime" label="回传时间" width="160" show-overflow-tooltip="true">
               </el-table-column>
               <el-table-column label="回传初筛明细文件名称" align="center" width="200">
                   <template slot-scope="scope">
                       <div>
                           <el-button @click="getBase64Online1(scope.row)" type="text" size="small">
                               {{scope.row.updateFileName}} </el-button>
                       </div>
                   </template>
               </el-table-column>
                <el-table-column label="操作" align="center" fixed="right" width="100">
                    <template slot-scope="scope">
                        <div>
                            <el-button size="mini" type="danger" v-show="scope.row.fileName && !scope.row.fileName.endsWith('.pdf')" @click="forUpload(scope.row)">上传</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

            <el-row style="margin: 18px 8px">
                <el-col :span="24">
                    <pagination v-show="pagination.total/pagination.pageSize>1"
                        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total"
                        :page.sync="pagination.page" :limit.sync="pagination.pageSize" @pagination="onFilter" />
                </el-col>
            </el-row>
            <el-dialog title="上传初筛明细文件" :append-to-body="true" :width="'80%'" :visible.sync="view.showUpload">
                <Upload v-if="view.showUpload" @reload="onFilter" v-bind:entity="entityData"></Upload>
            </el-dialog>
        </el-main>
    </el-container>
</template>

<script>
    import Upload from "./upload.vue";
    let _kits, _table
    export default {
        components: {
            Upload
        },
        data() {
            return {
                einvoiceDay: null,
                isShowLoading: true,
                isShowItem: false,
                //pageWidth: 600,
                //页面布局相关
                layout: {
                    loading: true,
                    width: 600,
                    wd: "80%",
                    edit: false
                },
                view: {
                    showUpload: false
                },
                //数据绑定相关
                filterData: {}, //过滤信息
                recordData: [], //展示信息
                //yearOptions:[],
                //monthOptions:[],
                pagination: {
                    total: 0,
                    page: 1,
                    pageSize: 10
                }, //分页信息
                entityData: {} //具体某一项信息
            }
        },
        methods: {
            reset() {
                this.filterData = {};
            },
            onRowDblclick(row, column, event) {
                console.log(row)
            },
            onFilter() {
                console.log(_kits.data("filterData"))
                this.layout.loading = true
                this.view.showUpload = false;
                _table.load()
            },
            init() {
                _table.load()
            },
            back() {
                //console.log("back")
                this.layout.edit = false
            },
            getBase64Online(item) {
                _kits.api.call(
                    "DOWNLOADFILE", {
                        fileName: item.fileName,
                        filePath: item.filePath
                    },
                    function(result) {
                        if (result.returnCode == "0000") {
                            console.log(result);
                            //alert(result.data.servletpath);
                            let a = document.createElement("a");
                            a.download = result.data.fileName;
                            //let data_head = "data:;base64,";
                            //a.href = data_head + result.data.fileBase64;
                            a.href = result.data.servletpath;
                            document.querySelector("body").appendChild(a);
                            a.click();
                            document.querySelector("body").removeChild(a);
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                )
            },
            getBase64Online1(item) {
                _kits.api.call(
                    "DOWNLOADFILE", {
                        fileName: item.updateFileName,
                        filePath: item.updateFilePath
                    },
                    function(result) {
                        if (result.returnCode == "0000") {
                            console.log(result);
                            //alert(result.data.servletpath);
                            let a = document.createElement("a");
                            a.download = result.data.fileName;
                            //let data_head = "data:;base64,";
                            //a.href = data_head + result.data.fileBase64;
                            a.href = result.data.servletpath;
                            document.querySelector("body").appendChild(a);
                            a.click();
                            document.querySelector("body").removeChild(a);
                        } else {
                            this.$message.error(result.returnMsg);
                        }
                    }
                )
            },
            forUpload(item) {
                this.entityData = {
                    id: item.id
                };
                this.view.showUpload = true
            }
        },
        created() {
            //this.pageWidth = window.innerWidth - 200
            _kits = this.$kits()
            _table = _kits.table(
                "QUERYFILELISTALL",
                () => {
                    return Object.assign({}, this.filterData, this.pagination)
                },
                result => {
                    this.isShowLoading = false
                    this.recordData = result.list
                    this.pagination.total = Number.parseInt(result.total)
                }
            )
            this.init()
        },
        mounted() {

        },
        computed: {},
    }
</script>
<style scoped>
</style>
